var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43.75 50.37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.32 50.37v-11.87h3.04v-7.59h-9.11v7.59h3.04v11.87h-20.29v-11.87h2.9v-26.63h-2.9v-11.87h20.29v11.87h-3.04v6.07h9.11v-6.07h-3.04v-11.87h20.43v11.87h-3.04v26.63h3.04v11.87z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.84 48.85v-8.83h3.04v-10.63h-12.15v10.63h3.04v8.83h-17.25v-8.83h2.9v-29.67h-2.9v-8.83h17.25v8.83h-3.04v9.11h12.15v-9.11h-3.04v-8.83h17.39v8.83h-3.04v29.67h3.04v8.83z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.97 47.36v-5.7h2.92v-32.91h-2.92v-5.7h14.18v5.7h-2.99v12.32h15.17v-12.32h-2.99v-5.7h14.25v5.7h-2.99v32.91h2.99v5.7h-14.25v-5.7h2.99v-13.82h-15.17v13.82h2.99v5.7z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/h.4ae24dca7128840fd7f78a0c3e26640c.svg";
export { ForwardRef as ReactComponent };